// Las claves son el nombre del rol que devuelve POST /login (data.rol)
const Roles = {
    ADMIN: { role: 'admin', home: '/ubicaciones' },
    REPONEDOR: { role: 'reponedor', home: '/ubicaciones' },
    ALMACEN: { role: 'almacen', home: '/ubicaciones' },
    SAT: { role: 'sat', home: '/ubicaciones' },
    MARKETING: { role: 'marketing', home: '/ubicaciones' },
    // Cuentas de dispositivo de las colas: kiosko donde se saca turno, display de llamadas
    // y pantalla del almacén (turnos con sus pedidos). El backend solo les deja llamar a
    // /colas y /entradas-cola (ver api/docs/api/colas.md)
    PANTALLA_TICKET: { role: 'pantalla_ticket', home: '/colas/seleccionar' },
    PANTALLA_LLAMADAS: { role: 'pantalla_llamadas', home: '/colas/seleccionar' },
    PANTALLA_ALMACEN: { role: 'pantalla_almacen', home: '/colas/seleccionar' }
};

export const ROLES_PANTALLA = [Roles.PANTALLA_TICKET.role, Roles.PANTALLA_LLAMADAS.role, Roles.PANTALLA_ALMACEN.role];

/**
 * Indica si el usuario es una cuenta de pantalla de colas: estas cuentas se pintan
 * sin cabecera ni menú y no cargan los datos globales de la aplicación
 * @param {Object|null} user - Usuario de AuthService.getCurrentUser()
 * @returns {boolean} true si alguno de sus roles es de pantalla
 */
export const esCuentaPantalla = (user) =>
    Boolean(user?.roles?.some((rol) => ROLES_PANTALLA.includes(rol)));

export default Roles;
